export default "__VITE_ASSET__CgJJFpx1__"